export function dropdown(ctx) {
    return {
        styles: {
            // radius: 4 removed (was neither the schema default nor a firmware match — see
            // roller.js/btnmatrix.js for the same fix; ctx.pretty's own radius, 8, matches
            // lv_theme_material.c's `bg` style and the material-dark sibling's explicit 8).
            // text_color removed — identical to ctx.pretty's own text_color (redundant duplicate).
            main: { ...ctx.pretty, text_font: 32, padding: 0 },
            // item_buttons has no LVGL counterpart (OpenHASP-specific per-row styling hook, see
            // dropdown.js schema comment) — radius aligned to 8 to match main/material-dark's own
            // choice instead of the previous unexplained 4.
            item_buttons: {
                bg_color:     ctx.COLOR_BG,
                border_color: ctx.COLOR_BG_BORDER,
                border_width: 1,
                radius:       8,
                text_color:   ctx.COLOR_BG_TEXT,
                padding:      0,
            },
            selected: { bg_color: ctx.accent },
        },
    };
}
